import React from 'react';

/**
 * Overview stat cards grid for the progress page.
 */
export default function OverviewCards({ stats, streak }) {
  const items = [
    { label: 'Cards Studied', value: stats.totalCardsStudied, sub: `${stats.totalCards} total` },
    { label: 'Exams Completed', value: stats.examsCompleted, sub: `${stats.totalFlashcardSessions} flashcard sessions` },
    { label: 'Drill Sessions', value: stats.drillSessions, sub: `${Math.round((stats.drillAccuracy || 0) * 100)}% accuracy` },
    { label: 'Study Streak', value: `${streak.currentStreak}🔥`, sub: `Best: ${streak.longestStreak} days` },
    { label: 'Overall Readiness', value: `${stats.overallReadiness}%`,
      color: stats.overallReadiness >= 70 ? '#2ECC71' : stats.overallReadiness >= 40 ? '#F39C12' : '#E74C3C',
      sub: stats.overallReadiness >= 82.5 ? 'On track to pass!' : 'Keep studying!' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
      {items.map(item => (
        <div key={item.label} className="bg-gray-800/50 border border-gray-700/50 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-white" style={item.color ? { color: item.color } : undefined}>
            {item.value}
          </div>
          <div className="text-xs text-gray-400 mt-1">{item.label}</div>
          {item.sub && <div className="text-xs text-gray-600 mt-0.5">{item.sub}</div>}
        </div>
      ))}
    </div>
  );
}
